import React, {useContext, useState} from 'react';
import CommonSpaceHeader from "../../../components/common/CommonSpaceHeader";
import {Box} from "../../../components/box";
import roomStore from "../../../store/roomStore";
import timeStore from "../../../store/timeStore";
import numStore from "../../../store/numStore";
import {SpaceContext} from "../../../contexts/spaceContext";
import moment from "moment";
import {UserContext} from "../../../contexts/userContext";
import {toast, ToastContainer} from "react-toastify";
import {observer} from "mobx-react";
import pinStore from "../../../store/pinStore";
import {isMobile} from "react-device-detect";
import async from "async";
import {LocStore} from "../../../utils";
import {axiosHandler} from "../../../network";

import 'moment/locale/ko'
import 'react-toastify/dist/ReactToastify.css';
import {createPortal} from "react-dom";
import Alertpopup from "../../../components/alertpopup";
import Smsfailed from "../../../components/alertpopup/Smsfailed";
import {jwtDecode} from "jwt-decode";


let callbackFlag33 = false;
let callbackFlag55 = false;

const ConfirmData = observer(({ setSms, sms }) => {
    const [reservationResult, setReservationResult] = useState(true);
    const [user] = useContext(UserContext);
    const shopData = roomStore.getShopData() ?? {};
    const timeData = timeStore.getTime() ?? [];
    const ppl = numStore.getNowppl() ?? 0;
    const code = pinStore.getPinCode() ?? {}
    const reservedTime = LocStore('reservedTime');
    let params = new URLSearchParams(window?.location?.search)
    let userI = jwtDecode(LocStore('userToken'))

    const relay = LocStore('relay') ?? 'N'
    // console.log(params.get('imp_uid'))
    // console.log(params.get('merchant_uid'))
    // console.log(params.get('imp_success'))

    const [state] = useContext(SpaceContext)
    const room = state.filter(item => item['key'] === 'space')[0]['value']
    const date = state.filter(item => item['key'] === 'date')[0]['value']

    const roomData = numStore.getRoomInfo() ?? {};

    const validResult = Boolean(reservationResult);

    const start = timeData?.[0]?.['start'];
    const end = timeData?.[timeData.length - 1]?.['end']


    const et = end?.split(':')[0]
    const em = end?.split(':')[1]
    const st = start?.split(':')[0]
    const sm = start?.split(':')[1]


    const tt1 = Number(st) * 60 + Number(sm)
    const tt2 = Number(et) * 60 + Number(em)
    const diff=  tt2 - tt1;
    const h = Math.floor(diff / 60)
    const l = diff % 60;



    // useEffect(() => {
    //     console.log({shopData})
    //     console.log({timeData})
    //     console.log({ppl})
    //     console.log({code})
    //     console.log({roomData})
    // }, []);



    // console.log(sdCode, sdPin)
    function copyClipboard() {

        let data = document.querySelector('.final_info').innerText;
        // console.log(document.querySelector('.final_info'))
        // console.log(data)
        data = data.replace('<p>', '\n')

        try {
            navigator.clipboard.writeText(data).then(() => {

                toast('복사되었습니다.', {
                    position: "top-center",
                    autoClose: 2000,
                    draggable: false,
                    hideProgressBar: true,
                    closeOnClick: true,
                    limit: 1,
                })

                console.log('Content Copied')

            })
        }catch(err) {
            toast.error(err?.message)
            console.error('Failed to Copy', err?.message)
        }

    }

    if(isMobile && !callbackFlag55) {
        callbackFlag55 = true;

        let uid = params.get('imp_uid');
        // let merchantUid = params.get('merchant_uid');
        let success = params.get('imp_success');
        // console.log(uid, success)

        console.log(success, '모바일 성공여부');

        // console.log('모바일 토큰값ssss', LocStore(`shopToken_${shopStore.spno}`))
        const mobileFinal = async ()=> {
            return new Promise((resolve, reject) => {
                try {
                    async.waterfall([
                        (callback) => {
                            let finalData = {
                                transactionUid: uid,
                                member: LocStore('userToken')
                            }

                            if(!callbackFlag33) {
                                callbackFlag33 = true;

                                console.log('여러번 호출 이유', callbackFlag33);

                                axiosHandler({ method: 'POST', url: `/rooms/${LocStore('roomNo')}/reservation`, data: finalData, token: `Bearer ${LocStore(`shopToken_${LocStore('spno')}`)}`}).then((res) => {
                                    console.log('모바일 결제', res)
                                    if (res?.data?.data?.errorCode) {
                                        callback(res, null);
                                    } else {
                                        callback(null, res?.data?.data);
                                    }
                                }).catch((err) => {
                                    setReservationResult(false);
                                    callback(err, null);
                                });

                            }

                            // console.log(LocStore('spno'), '모바일 결제 체크');
                        },
                    ], (err, result) => {
                        console.log(err, '결제 취소 및 실패');
                        console.log(result, '결제 결과');

                        if (err) {
                            if(!result?.smsResult) setSms(true);
                            reject(err?.data?.data?.errorCode);
                        } else if (result?.sdCode && result?.sdPin) {
                            pinStore.setPinCode(result?.sdCode, result?.sdPin);
							console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@');
							console.log(result.reservedTime);
							console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@');
                            timeStore.setReservedTime(result.reservedTime);

                            resolve(result);
                        } else {
                            console.log('result?.message', result?.message);

                            resolve(result);
                        }
                    });
                } catch(err) {
                    reject(err);
                }
            });
        }

        if (success) {
            mobileFinal();
        }
    }



    let locData = LocStore('userInfo') ?? {};
    return (
        <>
            {validResult ? (
                <h2>예약확정</h2>
            ) : (
                <h2 style={{color: 'var(--danger-text)'}}>예약실패</h2>
            )}
            <CommonSpaceHeader/>
            {validResult && (
                <>
                    <Box className='ttl_box'>
                        <h3>이용 안내</h3>
                        <button
                            onClick={copyClipboard}
                            type='button'
                        >복사
                        </button>
                    </Box>
                    <Box className='jumbotron_box'>
                        <div className='final_info'>
                            <p className='first'>{userI?.['mbName'] || locData?.['username']}님, {shopData?.['spTitle']} 결제가 완료되었습니다.</p>

                            <p className='first'>이용일시 : {
                                (reservedTime && reservedTime.reservedTime) ?
                                    reservedTime.reservedTime :
                                    timeStore.getReservedTime() ? timeStore.getReservedTime() : `${moment(date ?? locData?.['timed']?.['duration'])?.format('yyyy.MM.DD ddd')} ${start ?? locData?.['timed']?.['start']} ~ ${end ?? locData?.['timed']?.['end']}`
                            } /  { (isMobile) ?`${locData?.['timed']?.['totalHour']}` : `${h > 0 ? `${h}시간` : ''} ${l > 0 ? `${l}분` : ''}`}/ {ppl || locData?.['ppl']
                            }명
                            </p >

                            {
                                relay === 'Y' ? (
                                    <>
                                        <p className='first'>[입실/퇴실방법]</p>
                                        <p>1. 결제 완료 후 키오스크 화면에서 [바로 입실] 버튼 클릭</p>
                                        <p>2. (바로 입실하지 못할 경우) <br/>키오스크에서 전화번호 인증 후 [입실] 버튼 클릭</p>
                                        <p>3. 퇴실 시 키오스크에서 전화번호 인증 후 [퇴실] 버튼 클릭</p>
                                        <p>4. 이용시간 전후 5분까지 입/퇴실 가능</p>
                                    </>
                                ) : (
                                    <>
                                        <p>ID : {code?.sdCode}</p>
                                        <p>PIN 번호 : {code?.sdPin}</p>

                                        <p className='first'>[입실/퇴실방법]</p>
                                        <p>1. 지문인식기 입실/퇴실/버튼</p>
                                        <p>2. {code?.sdCode} 입력 후 OK버튼</p>
                                        <p>3. {code?.sdPin} 입력 후 OK버튼</p>
                                        <p>4. 이용시간 5분전, 종료5분후까지 입/퇴실 가능합니다.</p>
                                    </>
                                )
                            }


                            {/*<p className='first' style={{ fontWeight: 'bold'}}>[예약변경 및 취소/환불요청]</p>*/}
                            <p style={{ paddingTop: '8px' }}>예약변경 및 취소, 환불 문의는 해당 지점으로 문의 부탁드립니다.</p>

                        </div>
                    </Box>
                </>
            )}
            <ToastContainer autoClose={2000} limit={1} icon={false} hideProgressBar={true} closeOnClick={true} />
            {
                sms && createPortal(<Alertpopup><Smsfailed setSms={setSms} /></Alertpopup>, document.body)
            }
        </>
    );
});

export default ConfirmData;
